<template>
  <div class="ccgd-toolbar">
    <div class="ccgd-search">
      <i class="fa-duotone fa-magnifying-glass ccgd-ico ccgd-ico--tb"></i>

      <!-- <select
        class="ccgd-search-field"
        :value="searchField"
        @change="$emit('search-field-change', $event.target.value)"
      >
        <option
          v-for="option in searchFieldOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.text }}
        </option>
      </select> -->

      <k-input
        class="ccgd-search-input"
        placeholder="Search..."
        :value="searchWord"
        @input="$emit('search', $event.value)"
      />

      <kbutton v-if="searchWord" class="ccgd-clear" @click="$emit('clear-search')" title="Clear">
        <i class="fa-duotone fa-xmark ccgd-ico ccgd-ico--tb"></i>
      </kbutton>
    </div>

    <div class="ccgd-toolbar-right">
      <div v-if="incompleteAppSwitch" class="ccgd-switch-pill">
        <i class="fa-duotone fa-sitemap ccgd-ico ccgd-ico--tb"></i>
        <span class="ccgd-switch-label">Showing</span>

        <k-switch
          class="ccgd-scope-switch"
          :onLabel="'All'"
          :offLabel="'Mine'"
          :size="'medium'"
          :checked="incompleteAppSwitchChecked"
          @change="$emit('toggle-incomplete-app-switch')"
        />
      </div>

      <kbutton class="ccgd-btn ccgd-btn-outline" @click="$emit('export')">
        <i class="fa-duotone fa-file-excel ccgd-ico ccgd-ico--excel"></i>
        Export Excel
      </kbutton>
    </div>
  </div>
</template>

<script>
import { Button } from "@progress/kendo-vue-buttons"
import { Input, Switch } from "@progress/kendo-vue-inputs"

export default {
  name: "GridDialogToolbar",
  components: {
    kbutton: Button,
    "k-input": Input,
    "k-switch": Switch
  },
  props: {
    searchWord: { type: String, default: "" },
    searchField: { type: String, default: "all" },
    searchFieldOptions: {
      type: Array,
      default: () => [
        { value: "all", text: "All Fields" }
      ]
    },
    viewMode: { type: String, default: "list" },
    allSelected: { type: Boolean, default: false },
    incompleteAppSwitch: { type: Boolean, default: false },
    incompleteAppSwitchChecked: { type: Boolean, default: false }
  },
  emits: [
    "search",
    "search-field-change",
    "clear-search",
    "toggle-select-all",
    "toggle-incomplete-app-switch",
    "export"
  ]
}
</script>

<style scoped>
.ccgd-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.ccgd-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 520px;
  min-width: 280px;
}

.ccgd-search-field {
  height: 38px;
  min-width: 160px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 800;
  color: #24314f;
  outline: none;
}

.ccgd-search-input {
  flex: 1 1 auto;
  min-width: 180px;
}

.ccgd-toolbar-right {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ccgd-switch-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ccgd-switch-label {
  font-size: 12px;
  font-weight: 800;
  color: #5b657a;
}

.ccgd-clear {
  min-width: 38px;
  width: 38px;
  height: 38px;
  border-radius: 10px;
}

.ccgd-ico--tb {
  --fa-primary-color: var(--notification-blue);
  --fa-secondary-color: rgba(37, 99, 235, 0.26);
  --fa-secondary-opacity: 1;
}

.ccgd-ico--excel {
  --fa-primary-color: #16a34a;
  --fa-secondary-color: rgba(22, 163, 74, 0.25);
  --fa-secondary-opacity: 1;
}

.ccgd-toolbar .ccgd-ico {
  font-size: 15px;
  opacity: 0.95;
}

.cgsdark .ccgd-search-field {
  background: rgba(15, 23, 42, 0.78);
  border-color: rgba(148, 163, 184, 0.16);
  color: rgba(226, 232, 240, 0.92);
}

.cgsdark .ccgd-switch-label {
  color: rgba(226, 232, 240, 0.78);
}
</style>